import { inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

// ngsw only checks for a new version on app start and navigation; Daisi tabs stay open for days
const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private updates = inject(SwUpdate);

  listenForUpdates() {
    if (!this.updates.isEnabled) {
      return;
    }

    setInterval(() => this.checkForUpdate(), UPDATE_CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.checkForUpdate();
      }
    });

    // Trigger reload when a new version is ready
    this.updates.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        const userWantsReload = confirm(
          'Er is een nieuwe versie beschikbaar. Wil je de pagina verversen?',
        );

        if (userWantsReload) {
          document.location.reload();
        }
      }
    });

    // The service worker can no longer serve this version (e.g. its cached assets were evicted)
    this.updates.unrecoverable.subscribe(() => document.location.reload());
  }

  private checkForUpdate() {
    this.updates.checkForUpdate().catch((err) => console.error('Could not check for updates', err));
  }
}
